import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Что-то пошло не так, попробуйте перезагрузить страницу',
  submit: 'Перезагрузить',
} satisfies TMessages
